import * as React from 'react';
import { observer } from 'mobx-react';
import { configurationsStore } from 'utils/MobxDataManager/singletons';
import './emailManagementContainer.scss';
import { INotificationDisabledUser } from 'typings/MobxComponents/notificationDisabledUser';
import { EmailManagementListRow } from 'nomst/Components/CycleSettings/emailManagementListRow';

interface IEmailManagementContainerProps {
    isDisabled: boolean;
}

export class EmailManagementContainer extends React.Component<IEmailManagementContainerProps> {
    render(): React.ReactNode {

        const { notificationDisabledUsers } = configurationsStore;
        return (
            <div className="email-management-container">
                <div>
                    <div className="email-management-container__sub-header">
                        Managers with Emails Disabled ({notificationDisabledUsers?.length})
                    </div>
                    {this.renderEmailManagementListRows(notificationDisabledUsers)}
                </div>
            </div>
        );
    }

    private renderEmailManagementListRows(
        notificationDisabledUsers: Nullable<INotificationDisabledUser[]>): React.ReactNode {
        return (
            notificationDisabledUsers?.map((notificationDisabledUser) => {
                return (
                    <EmailManagementListRow
                        key={notificationDisabledUser.workEmail}
                        notificationDisabledUser={notificationDisabledUser}
                        isDisabled={this.props.isDisabled}
                    />
                );
            }
            ));
    }
}

export default observer(EmailManagementContainer);